var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "OrderDetails",
      staticStyle: {
        padding: "20px 5px",
        background: "#ffffff",
        "box-shadow": "rgb(107 105 105 / 21%) 0px 0px 20px 0px",
        "border-radius": "10px"
      }
    },
    [
      _c(
        "p",
        {
          staticClass: "comeback",
          on: {
            click: function($event) {
              return _vm.comeback()
            }
          }
        },
        [
          _c("span", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Return")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "RequestInfo divbox",
          staticStyle: { margin: "3px 29px" }
        },
        [
          _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_Order_info")))]),
          _vm._v(" "),
          _c("ul", { staticClass: "RI_ul" }, [
            _c("li", [
              _c("p", [
                _c("span", {}, [
                  _vm._v(_vm._s(_vm.$t("i18n_Tracking_number")) + " ")
                ]),
                _c("span", [_vm._v(_vm._s(_vm.routes.nos || "-"))])
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.$t("i18n_destination")))]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.Alldata.waybilldetails.pod_country || "-") +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [
                _c("span", {}, [
                  _vm._v(_vm._s(_vm.$t("i18n_Shipping_method")) + " ")
                ]),
                _c("span", [
                  _vm._v(_vm._s(_vm.Alldata.waybilldetails.transportway || "-"))
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Order_date")))]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.Alldata.waybilldetails.inputtime || "-") +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [
                _c("span", {}, [
                  _vm._v(_vm._s(_vm.$t("i18n_Original_Port")) + " ")
                ]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.Alldata.waybilldetails.warehouse || "-") +
                      "\n              "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("i18n_arrived_warehouse_date")))
                ]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.Alldata.waybilldetails.inwarehousetime || "-"
                      ) +
                      "\n            "
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "jackCard", staticStyle: { padding: "20px" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              attrs: {
                src: require("./../../../assets/receiveIcon.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "margin-left": "10px",
                  "font-size": "20px",
                  "font-weight": "550"
                }
              },
              [_vm._v(_vm._s(_vm.$t("i18n_Package_info")))]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "reCard" }, [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "18px",
                "line-height": "40px",
                "font-weight": "600"
              }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(
                    (_vm.Alldata.deswarehouse &&
                      _vm.Alldata.deswarehouse.warehouse) ||
                      _vm.$t("i18n_no_receiving_information")
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { "line-height": "40px" } }, [
            _vm._v(
              "\n           " +
                _vm._s(
                  (_vm.Alldata.deswarehouse && _vm.Alldata.deswarehouse.tel) ||
                    ""
                ) +
                "\n          " +
                _vm._s(
                  (_vm.Alldata.deswarehouse &&
                    _vm.Alldata.deswarehouse.province) ||
                    ""
                ) +
                "\n          " +
                _vm._s(
                  (_vm.Alldata.deswarehouse && _vm.Alldata.deswarehouse.city) ||
                    ""
                ) +
                "\n          " +
                _vm._s(
                  (_vm.Alldata.deswarehouse && _vm.Alldata.deswarehouse.area) ||
                    ""
                ) +
                "\n          " +
                _vm._s(
                  (_vm.Alldata.deswarehouse &&
                    _vm.Alldata.deswarehouse.address) ||
                    ""
                ) +
                "\n        "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.Alldata.message.isgetgoodstodoor
        ? _c(
            "div",
            {
              staticClass: "jackCard",
              staticStyle: {
                overflow: "hidden",
                background: "rgb(253 246 217)"
              }
            },
            [
              _c("div", { staticStyle: { padding: "10px 30px" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "26rpx",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#c19822",
                      "line-height": "40rpx"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "i18n_Please_ship_your_package_to_below_warehouse"
                        )
                      )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { background: "#fff", padding: "15px 30px" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-family": "PingFang SC",
                        "font-weight": "550"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Alldata.depwarehouse.warehouse || "") +
                          "\n\n        "
                      )
                    ]
                  ),
                  _vm._v(
                    "\n\n         " +
                      _vm._s(_vm.Alldata.depwarehouse.tel || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.province || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.city || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.area || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.address || "") +
                      "\n      "
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.Alldata.message.isgetgoodstodoor
        ? _c(
            "div",
            {
              staticClass: "jackCard",
              staticStyle: {
                overflow: "hidden",
                background: "rgb(253 246 217)"
              }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { background: "#fff", padding: "15px 30px" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-family": "PingFang SC",
                        "font-weight": "550"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Alldata.message.getgoodsname || "") +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { margin: "0 10px" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.Alldata.message.getgoodstel || "") +
                        "\n        "
                    )
                  ]),
                  _vm._v(
                    "\n        \n        " +
                      _vm._s(_vm.Alldata.message.getgoodsprovince || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.message.getgoodscity || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.message.getgoodsarea || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.message.getgoodsaddress || "") +
                      "\n      "
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "jackCard", staticStyle: { padding: "30px" } }, [
        _c("div", [
          _c(
            "span",
            {
              class: {
                jackTextAc: _vm.acIndex == 1,
                jackText: _vm.acIndex == 2
              },
              staticStyle: { cursor: "pointer", "margin-right": "5px" },
              on: {
                click: function($event) {
                  return _vm.changeAc(1)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("i18n_Forecast_pakcage_info")))]
          ),
          _vm._v(" "),
          _vm.state == 2
            ? _c(
                "span",
                {
                  class: {
                    jackTextAc: _vm.acIndex == 2,
                    jackText: _vm.acIndex == 1
                  },
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function($event) {
                      return _vm.changeAc(2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_Accurated_package_info")))]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.acIndex == 1
          ? _c(
              "div",
              { staticStyle: { margin: "20px 0" } },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      border: "",
                      data: _vm.Alldata.cargobefore,
                      "tooltip-effect": "dark",
                      "header-cell-style": { background: "#F3F3F3" }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: _vm.$t("i18n_Serial_number"),
                        width: "75px",
                        "min-width": "8%"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "boxNo",
                        label: _vm.$t("i18n_FBA_number")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.boxNo || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1764604676
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "citiBoxNo",
                        label: _vm.$t("i18n_Cititrans_Tracking_number")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.citiBoxNo || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1829474195
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "sortNum",
                        label: _vm.$t("i18n_box_counting_number")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.sortNum || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3181543292
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "poTrackingNo",
                        label: _vm.$t("i18n_Amazon_Reference_Number_PO")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.poTrackingNo || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4001794209
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goodstype",
                        label: _vm.$t("i18n_cargo_classification")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.goodstype || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1052843960
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "weight",
                        label: _vm.$t("i18n_weight_kgs")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.weight || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2760248880
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "cbm", label: _vm.$t("i18n_volume_cbm") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.cbm || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        165649564
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "cbmSize",
                        label: _vm.$t("i18n_size_cm"),
                        "min-width": "100px"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.cbmSize || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3651899641
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "pcs", label: "PCS数" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.pcs || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        203148016
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "skuNo",
                        label: _vm.$t("i18n_sku_number")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.skuNum || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2036918827
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        "min-width": "100px",
                        prop: "piece",
                        label: _vm.$t("i18n_Operation")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "detailSpan",
                                    on: {
                                      click: function($event) {
                                        return _vm.getBoxDetail(
                                          scope.row.goodsList
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("i18n_view_details")))]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1565440206
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _c("div", { staticStyle: { margin: "20px 0" } }, [
              _c(
                "div",
                { staticClass: "tablebox" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        border: "",
                        data: _vm.Alldata.cargo,
                        "tooltip-effect": "dark",
                        "header-cell-style": { background: "#F3F3F3" }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("i18n_Serial_number"),
                          width: "75px",
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "boxNo",
                          label: _vm.$t("i18n_FBA_number")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.boxNo || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "citiBoxNo",
                          label: _vm.$t("i18n_Cititrans_Tracking_number")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.citiBoxNo || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sortNum",
                          label: _vm.$t("i18n_box_counting_number")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.sortNum || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "poTrackingNo",
                          label: _vm.$t("i18n_Amazon_Reference_Number_PO")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.poTrackingNo || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goodstype",
                          label: _vm.$t("i18n_cargo_classification")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.goodstype || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "weight",
                          label: _vm.$t("i18n_weight_kgs")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.weight || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cbm",
                          label: _vm.$t("i18n_volume_cbm")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.cbm || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cbmSize",
                          label: _vm.$t("i18n_size_cm"),
                          "min-width": "100px"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.cbmSize || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pcs",
                          label: _vm.$t("i18n_sku_number")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.pcs || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          width: "140px",
                          prop: "piece",
                          label: _vm.$t("i18n_Operation")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "text-align": "left"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "detailSpan",
                                      on: {
                                        click: function($event) {
                                          return _vm.getBoxDetail(
                                            scope.row.goodsList
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("i18n_view_details"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  scope.row.pictureUrl
                                    ? _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "top-start",
                                            title: "",
                                            "popper-class": "look-image",
                                            trigger: "hover"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "detailSpan",
                                              attrs: { slot: "reference" },
                                              slot: "reference"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("i18n_view_pictures")
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          [
                                            scope.row.pictureUrl
                                              ? _c("el-image", {
                                                  staticClass:
                                                    "table-goods-cover",
                                                  attrs: {
                                                    src: scope.row.pictureUrl,
                                                    "preview-src-list": [
                                                      scope.row.pictureUrl
                                                    ]
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "el-link",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  underline: false
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.downFile(
                                                      scope.row.pictureUrl || ""
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("下载图片")]
                                            )
                                          ]
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "detailSpan",
                                      on: {
                                        click: function($event) {
                                          return _vm.toBoxTracking(
                                            scope.row.boxNo
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("i18n_view_tracking"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "Information divbox",
          staticStyle: { margin: "3px 29px" }
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("i18n_shipping_fee_info"),
                    name: "second"
                  }
                },
                [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: {
                        width: "77%",
                        "margin-left": "25px",
                        "border-bottom": "none"
                      },
                      attrs: {
                        border: "",
                        data: _vm.tableData1,
                        "tooltip-effect": "dark",
                        "header-cell-style": { background: "#F3F3F3" }
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("i18n_Serial_number"),
                          width: "75px",
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Total_payment") &&
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Covert_to_CNY")
                                  ? _c("span", [
                                      _vm._v(_vm._s(parseInt(scope.$index + 1)))
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "feeitem",
                          label: _vm.$t("i18n_cost_category"),
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amountBefore",
                          label: _vm.$t("i18n_estimated_cost"),
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.tableData1[scope.$index]
                                        .amountBefore || "-"
                                    ) +
                                    "\n                " +
                                    _vm._s(
                                      "(" +
                                        (_vm.tableData1[scope.$index]
                                          .amountBeforeCalDesc || "-") +
                                        ")" || "-"
                                    ) +
                                    "\n              "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amount",
                          label: _vm.$t("i18n_actual_cost"),
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.tableData1[scope.$index].amount
                                    ) +
                                    "\n                " +
                                    _vm._s(
                                      "(" +
                                        (_vm.tableData1[scope.$index]
                                          .amountCalDesc || "-") +
                                        ")" || "-"
                                    ) +
                                    " \n              "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: {
                        width: "77%",
                        "margin-left": "25px",
                        "border-top": "none",
                        "margin-top": "0px"
                      },
                      attrs: {
                        border: "",
                        data: _vm.twotableData,
                        "cell-style": { padding: "5px 0px" },
                        "show-header": false
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "",
                          width: "75px",
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Total_payment") &&
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Covert_to_CNY")
                                  ? _c("span", [
                                      _vm._v(_vm._s(parseInt(scope.$index + 1)))
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "feeitem", label: "", "min-width": "8%" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amountBefore",
                          label: "",
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "amount", label: "", "min-width": "8%" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: { label: _vm.$t("i18n_tracking_info"), name: "third" }
                },
                [
                  !_vm.activities.length
                    ? _c(
                        "p",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "padding-top": "50px",
                            "font-size": "16px"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("i18n_no_tracking_status_yet")) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activities.length != 0
                    ? _c(
                        "div",
                        [
                          _vm.activities[0].fbxBoxTrailDTOList
                            ? _c(
                                "el-collapse",
                                _vm._l(_vm.activities, function(item, index) {
                                  return _c(
                                    "el-collapse-item",
                                    { key: index },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "LR_center",
                                            staticStyle: {
                                              width: "100%",
                                              float: "left"
                                            }
                                          },
                                          [
                                            _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "15px"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.commonNos))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "15px",
                                                    "font-weight": "bold"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.name))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "15px",
                                                    "font-weight": "bold"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.namee))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "15px",
                                                    color: "#999"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.occurrenceDate)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "5px",
                                                    color: "#999"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.occurrenceTime)
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#67C23A"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "i18n_more_tracking_status"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-timeline",
                                        { staticStyle: { padding: "0 30px" } },
                                        _vm._l(
                                          item.fbxBoxTrailDTOList,
                                          function(activity, _index) {
                                            return _c(
                                              "el-timeline-item",
                                              {
                                                key: _index,
                                                attrs: {
                                                  type: "primary",
                                                  color: activity.color
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                      float: "left",
                                                      "margin-bottom": "5px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          activity.occurrenceDate
                                                        )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "5px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            activity.occurrenceTime
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#999",
                                                      "font-size": "11px",
                                                      display: "block"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(activity.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    activity.desc
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "margin-left":
                                                                "10px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "(" +
                                                                _vm._s(
                                                                  activity.desc
                                                                ) +
                                                                ")"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(activity.namee)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    activity.apptWarehouseOrderId
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "text"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.GetshowText(
                                                                  activity
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("查询回执")]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    2
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.activities[0].fbxBoxTrailDTOList
                            ? _c(
                                "div",
                                {
                                  staticStyle: { width: "100%", float: "left" }
                                },
                                [
                                  _c(
                                    "el-card",
                                    { staticClass: "box-card" },
                                    _vm._l(_vm.activities, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "text item",
                                          staticStyle: {
                                            width: "100%",
                                            float: "left",
                                            "margin-bottom": "15px"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { float: "left" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "15px",
                                                    color: "#999"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.occurrenceDate
                                                    ) +
                                                      "\n                           "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.occurrenceTime
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticStyle: { float: "left" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "15px",
                                                    "font-weight": "bold"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.name))]
                                              ),
                                              _vm._v(" "),
                                              item.desc
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(item.desc) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "20px"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.namee))]
                                              ),
                                              _vm._v(" "),
                                              item.apptWarehouseOrderId
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#5AB53C",
                                                        cursor: "pointer"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.GetshowText(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v(" 查询回执")]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("i18n_download_labels"),
                    name: "download"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { margin: "10px" },
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.downLoadLabel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_click_and_download_labels")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "jackRadius",
          attrs: {
            center: "",
            "before-close": _vm.beforeClose,
            visible: _vm.showDialog,
            title: _vm.showPic ? "相关回执" : "箱子轨迹",
            width: "60%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          this.showDialog && this.showPic
            ? _c(
                "div",
                _vm._l(_vm.urls, function(item, index) {
                  return _c("el-image", {
                    key: index,
                    staticStyle: {
                      width: "45%",
                      height: "45%",
                      "border-radius": "20px",
                      margin: "10px",
                      "box-shadow": "0px 0px 55px 2px rgba(6, 2, 3, 0.1)"
                    },
                    attrs: { src: item, "preview-src-list": _vm.urls }
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          this.showDialog && this.showBox
            ? _c(
                "div",
                [
                  _c(
                    "el-timeline",
                    { staticClass: "jackContent" },
                    _vm._l(_vm.boxDatailList, function(activity, index) {
                      return _c(
                        "el-timeline-item",
                        {
                          key: index,
                          attrs: {
                            type: "primary",
                            icon: activity.icon,
                            color: index == 0 ? "" : "#999999",
                            timestamp:
                              activity.occurrenceDate +
                              " " +
                              activity.occurrenceTime
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(activity.name) +
                              "\n            "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#999999",
                                "margin-top": "6px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(activity.desc ? activity.desc : "暂无")
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "jackRadius",
          attrs: {
            center: "",
            visible: _vm.showGoodsList,
            title: _vm.$t("i18n_Box_Details"),
            width: "80%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showGoodsList = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "",
                  attrs: {
                    border: "",
                    size: "mini",
                    data: _vm.goodsList,
                    "tooltip-effect": "dark",
                    "header-cell-style": { background: "#5ab53c21" }
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _vm._v("\n          >"),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "boxNo",
                      label: _vm.$t("i18n_Product_name_in_Chinese")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.namec || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "poTrackingNo",
                      label: _vm.$t("i18n_product_name_in_English")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.namee || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "goodstype", label: _vm.$t("i18n_brands") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.brand || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "weight", label: "SKU" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.sku || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "number",
                      label: _vm.$t("i18n_product_quantity")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.number || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "cbm", label: _vm.$t("i18n_HTS_code") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.hsCode || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "pcs", label: _vm.$t("i18n_product_value") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  scope.row.price > 0 ? scope.row.price : "-"
                                ) +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_Material_in_Chinese")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.materialc || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_material_in_English")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.materiale || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_Product_uses_in_Chinese")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.purposec || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_Product_uses_in_English")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.purposee || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_Product_Images")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.pcs || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { padding: "10px 30px" } }, [
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "26rpx",
            "font-family": "PingFang SC",
            "font-weight": "500",
            color: "#c19822",
            "line-height": "40rpx"
          }
        },
        [_vm._v("提货信息")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ff71e5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ff71e5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/FBAheader/FbaOrderDetails.vue
// module id = null
// module chunks = 